import MainHeader from "../../components/common/MainHeader";
import React, { useState } from "react";
import { PATH } from "../../routes/Routes";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { useUserContext } from "../../hooks/UserSettingProvider";
import { Button, Space, Typography, Col, Row, Layout, Spin } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { Media } from "../../AppMedia";

export default function WoodMenusView(props) {
  const { t } = useTranslation();
  const history = useHistory();
  const { user } = useUserContext();

  const handleMenuClick = (path) => {
    history.push(path);
  };

  const adminMenu = [
    {
      id: "LOG_WOOD_PO",
      name: t("menus.wood_menus.log_wood_po"),
      onClick: () => handleMenuClick(PATH.LOG_WOOD_PO),
    },
    {
      id: "WOOD_IMPORT",
      name: t("menus.wood_menus.wood_import"),
      onClick: () => handleMenuClick(PATH.WOOD_IMPORT),
    },
    {
      id: "WOOD_IMPORT_SETTINGS_PRICE",
      name: t("menus.wood_menus.wood_import_settings_price"),
      onClick: () => handleMenuClick(PATH.WOOD_IMPORT_SETTINGS_PRICE),
    },
    {
      id: "FACTORY_WOOD_EXPORT",
      name: t("menus.wood_menus.factory_wood_export"),
      onClick: () => handleMenuClick(PATH.FACTORY_WOOD_EXPORT),
    },
  ];

  if (user.groups?.includes("officer")) {
    adminMenu.push({
      id: "BOM",
      name: t("menus.wood_menus.bom"),
      onClick: () => handleMenuClick(PATH.BOM),
    });
  }

  if (user.groups?.includes("export")) {
    adminMenu.push({
      id: "EXPORT_TRANSACTION",
      name: t("menus.wood_menus.export_transaction"),
      onClick: () => handleMenuClick(PATH.EXPORT_TRANSACTION),
    });
  }

  return (
    <div>
      {adminMenu.map((menu) => (
        <Row>
          <Col
            xs={{ offset: 2, span: 24 }}
            sm={{ offset: 7, span: 12 }}
            lg={{ offset: 9, span: 8 }}
            md={{ offset: 7, span: 13 }}
          >
            <br />
            <Button
              onClick={menu.onClick}
              size="large"
              type="primary"
              style={{
                width: "80%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {menu.name}
              <RightOutlined />
            </Button>
          </Col>
        </Row>
      ))}
    </div>
  );
}
